export const blockchainEventsName = {
  smartAsset: {
    transfer: 'Transfer',
    hydrated: 'Hydrated',
    recoveryRequestUpdated: 'RecoveryRequestUpdated',
    tokenRecovered: 'TokenRecovered',
    tokenURIUpdated: 'TokenURIUpdated',
    tokenAccessAdded: 'TokenAccessAdded',
    tokenDestroyed: 'TokenDestroyed',
    setNewUriBase: 'SetNewUriBase'
  },
  arianeeEvent: {
    eventCreated: 'EventCreated'
  },
  lost: {
    lost: 'Lost',
    retrieved: 'Retrieved'
  },
  identity: {
    IdentityValidate: 'URIValidate',
    IdentityUpdate: 'URIUpdated'
  },
  message: {
    MessageSent: 'MessageSent'
  }
};
